import { render, staticRenderFns } from "./Affiliator.vue?vue&type=template&id=608f2a60&scoped=true"
import script from "./Affiliator.vue?vue&type=script&lang=js"
export * from "./Affiliator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f2a60",
  null
  
)

export default component.exports